export default __webpack_public_path__ + "static/media/attila1.fb876059.jpg";